import { gql } from '@apollo/client';

/**
 * Generic broker for smallapp microservice action buttons declared in manifests
 * (Refresh Data, Test Connection, Force Sync, Validate, etc.). Open-api signs the
 * service-to-service token the microservice requires; the frontend only holds a
 * Firebase JWT which smallapp microservices do not accept.
 *
 * See `AssetService.smallappProxyAction` (open-api) for the server-side contract.
 */
export const SMALLAPP_PROXY_ACTION = gql`
  mutation SmallappProxyAction(
    $assetId: String!
    $endpoint: String!
    $method: String
    $body: JSONObject
    $teamId: String
  ) {
    smallappProxyAction(
      assetId: $assetId
      endpoint: $endpoint
      method: $method
      body: $body
      teamId: $teamId
    )
  }
`;

export interface SmallappProxyActionResult {
  smallappProxyAction: unknown;
}

export interface SmallappProxyActionVariables {
  assetId: string;
  endpoint: string;
  method?: 'GET' | 'POST' | 'PUT';
  body?: Record<string, unknown>;
  /**
   * Caller's ACTIVE team. Threaded into the resolver so `GetAuthContext` validates
   * against a team the user actually belongs to. Without it the gate defaults to
   * ROOT and rejects cross-team shared-folder users (Team-X member acting on a
   * Team-Y-owned asset) with INVALID_TEAM — the real per-asset folder-security
   * check (`_saveAsset`) never gets to run. Mirrors the useCurrentGroup pattern.
   */
  teamId?: string;
}
